import React, { Component, useCallback, useEffect, useMemo, useState } from 'react';
import endpoint_code_cases from '../data/2023-05/endpoint_code_cases__FG_pheno-r11_geno-r10__2023-05-17.json';
import legend from '../img/EB_legend.svg'
import Widget from './network/widget'
import * as d3 from "d3";

function Network (props) {
    const root = props.root
    const format = props.format
    const retrieve = props.retrieve
    const color = props.color
    const heatmap = props.heatmap
    const updateHeatmap = props.updateHeatmap
    const contentHeight = props.contentHeight
    const updateURL = props.updateURL
    const [extraNodes, setExtraNodes] = useState([]);
    const [widgetState, setWidgetState] = useState(false);
    const [widgetRoot, setWidgetRoot] = useState([]);
    let [widgetData, setWidgetData] = useState([]);

    function drawNetwork (edges, nodes) {
        nodes.forEach(node=>{
            if(node.cases===undefined){
                node.cases = 0
            }
        })

        //console.log('draw network nodes length', nodes.length)
        function updateEdges (data) {
            //console.log('edges', data)
            const maxCasesSource = d3.max(data, d => d.source.cases)
            const maxCasesTarget = d3.max(data, d => d.target.cases)
            const scaleCases = maxCasesSource > maxCasesTarget? d3.scaleLinear().domain([0,Math.sqrt(maxCasesSource)]).range([3,7]) : d3.scaleLinear().domain([0,Math.sqrt(maxCasesTarget)]).range([3,7])
            var distances = []
            data.forEach(edge => distances.push(edge.distance))
            var extentdistances = d3.extent(distances)
            const scaleEdge = d3.scaleLinear().domain(extentdistances).range([0.75, 3])

            d3.select('#network_edges').selectAll('.network_edge').data(data, e => e.id).join('line')
                .classed('network_edge',true)
                .attr('id', (d,i) => 'network_edge' + i)
                .style('marker-end', d => d.subsets ? "url('#arrowhead')" : undefined)
                .attr('x1',d => d.source.x + Math.cos(Math.atan2(d.target.y - d.source.y, d.target.x - d.source.x)) * (scaleCases(Math.sqrt(d.source.cases))))
                .attr('y1',d => d.source.y + Math.sin(Math.atan2(d.target.y - d.source.y, d.target.x - d.source.x)) * (scaleCases(Math.sqrt(d.source.cases))))
                .attr('x2',d => d.target.x - Math.cos(Math.atan2(d.target.y - d.source.y, d.target.x - d.source.x)) * (scaleCases(Math.sqrt(d.target.cases))))
                .attr('y2',d => d.target.y - Math.sin(Math.atan2(d.target.y - d.source.y, d.target.x - d.source.x)) * (scaleCases(Math.sqrt(d.target.cases))))
                .attr('stroke', color.violet)
                //.attr('stroke-width', d => scaleEdge(d.jaccard))
                .attr('stroke-width', d => scaleEdge(d.distance))
                //.on('mouseenter', (e,d) => showEdgeInfo('enter', e.x, e.y, d.colocs, d.rg, d.jaccard))
                //.on('mouseleave', (e,d) => showEdgeInfo('leave', e.x, e.y, d.colocs, d.rg, d.jaccard))
        }
    
        function updateNodes (data) {
            //console.log(data)
            const maxCases = d3.max(data, d => d.cases)
            const scaleCases = d3.scaleLinear().domain([0,Math.sqrt(maxCases)]).range([3,7])
            
            d3.select('#network_nodes').selectAll('.network_node').data(data, d => d.name)
                .join(enter => {
                    const geometry = enter.append('g')
                        .attr('class', 'network_node')
                        .on('mouseenter', (e,d) => highlightNode('enter', d.name))
                        .on('mouseleave', (e,d) => highlightNode('leave', d.name))
                        .on('click',  function(e,d)  {
                            let codes = [...nodes.map(e => e.name), ...extraNodes.map(e => e.name)];
                            let datasets = produceDatasets(props.data, d.name)
                            widgetData = datasets.inspection.filter(e => !codes.includes(e.code))
                            setWidgetData(widgetData)
                            setWidgetState(true)
                            setWidgetRoot(d)
                        })

                    geometry.append('circle')
                        .attr('class', 'network_node_dot')
                        .attr('fill', d => d.core === "yes" ? color.purple : 'white')
                        .attr('stroke', d => d.core === "yes" ? 'transparent' : color.purple)
                        .attr('stroke-width', d => d.core === "yes" ? 0 : 0.5)
                        .transition()
                        .attr('r', d => scaleCases(Math.sqrt(d.cases)))

                    geometry.append('text')
                        .attr('class', 'network_node_gwwas')
                        .attr('y', d => d.y+1.5)
                        .text(d => retrieve.gwas(d.name))
                        .style('font-size', 5)
                        .style('font-weight', 600)
                        .style('text-anchor', 'middle')
                        .attr('fill', 'white');
    
                    geometry.append('text')
                        .attr('class', 'network_node_label')
                        .attr('id', d => 'network_node_label_' + d.name)
                        .attr('x', d => d.x+1)
                        .attr('y', d => d.y+10 + (scaleCases(Math.sqrt(d.cases))/2))
                        .text(d => format.name(d.name))
                        .style('font-size', 8)
                        .style('font-weight', 600)
                        .attr('fill', d => d.name === root ? 'white' : color.gray);
    
                    geometry.append('rect')
                        .attr('class', 'network_node_rect')
                        .attr('id', d => 'network_node_rect_' + d.name)
                        .attr('x', d => d.x-2)
                        .attr('y', d => d.y+2.5 + (scaleCases(Math.sqrt(d.cases))/2))
                        .attr('width', d => document.getElementById('network_node_label_' + d.name).getBBox().width + 6)
                        .attr('fill', d => d.name === root ? color.purple : 'white')
                        .attr('height', 10.5)
                        .attr('rx', 1)
                        .style('opacity', 0.7)
                        .lower();
    
                    return geometry
                },update => {
                    update
                        .on('mouseenter', (e,d) => highlightNode('enter', d.name))
                        .on('mouseleave', (e,d) => highlightNode('leave', d.name))
                        .on('click',  function(e,d)  {
                            let codes = [...nodes.map(e => e.name), ...extraNodes.map(e => e.name)];
                            let datasets = produceDatasets(props.data, d.name)
                            widgetData = datasets.inspection.filter(e => !codes.includes(e.code))
                            setWidgetData(widgetData)
                            setWidgetState(true)
                            setWidgetRoot(d)
                        })
                    update.select('.network_node_dot')
                        .attr('cx', d => d.x)
                        .attr('cy', d => d.y)
                        .attr('r', d => scaleCases(Math.sqrt(d.cases)));
                    update.select('.network_node_gwwas')
                        .attr('x', d => d.x)
                        .attr('y', d => d.y+1.5)
                        .text(d => retrieve.gwas(d.name));
                    update.select('.network_node_label')
                        .attr('id', d => 'network_node_label_' + d.name)
                        .attr('x', d => d.x+1)
                        .attr('y', d => d.y+10.5 + (scaleCases(Math.sqrt(d.cases))/2))
                        .text(d => format.name(d.name))
                    update.select('.network_node_rect')
                        .attr('id', d => 'network_node_rect_' + d.name)
                        .attr('width', d => document.getElementById('network_node_label_' + d.name).getBBox().width + 6)
                        .attr('x', d => d.x-2)
                        .attr('y', d => d.y+2.5 + (scaleCases(Math.sqrt(d.cases))/2))
                })
        }
    
        function updateJaccards (data) {

            function getTransform (d,i) {
                const labelGeometry = document.querySelector('#network_jaccard_label' + i)
                if (labelGeometry) {
                    if (d.target.x < d.source.x) {
                        const bbox = labelGeometry.getBBox(),
                            rx = bbox.x + bbox.width / 2,
                            ry = bbox.y + bbox.height / 2;
                        return 'translate(0,2.8) rotate(180 ' + rx + ' ' + ry + ')';
                    } else {
                        return 'translate(0,-3) rotate(0) ';
                    }
                }
            }

            const tooltip = d3.select('#network').append('div')
                .attr("id", "tooltip")
            tooltip.append('p').attr('class', 'edge_info edge_info_jaccard')    
            tooltip.append('p').attr('class', 'edge_info edge_info_colocsame')
            tooltip.append('p').attr('class', 'edge_info edge_info_colocdiff')
            tooltip.append('p').attr('class', 'edge_info edge_info_rg')
            
            d3.select('#network_jaccards').selectAll(".network_jaccard").data(data, e => e.id).join(
                function(enter){
                    const geometry = enter.append('g')
                    .attr('class', 'network_jaccard')
                    .on('mouseenter', (e,d) => showEdgeInfo('enter', e.x, e.y, d.colocsame, d.colocdiff, d.rg, d.jaccard, d.index))
                    .on('mouseleave', (e,d) => showEdgeInfo('leave', e.x, e.y, d.colocsame, d.colocdiff, d.rg, d.jaccard, d.index));
    
                    geometry.append('path')
                        .attr('class', 'network_jaccard_path')
                        .attr('opacity', 0)
                        .attr('id', (d,i) => 'network_jaccard_path' + i)
                        .attr('d', d =>  'M ' + d.source.x + ' ' + d.source.y + ' L ' + d.target.x + ' ' + d.target.y);
        
                    geometry.append('text')
                        .attr('class', 'network_jaccard_label')
                        .attr('id', (d,i) => 'network_jaccard_label' + i)
                        .attr('font-size', 7)
                        .attr('fill', color.violet)
                        .attr('transform', (d,i) => getTransform(d,i))
                        .append('textPath')
                            .attr('xlink:href', (d,i) => '#network_jaccard_path' + i)
                            .style("text-anchor", "middle")
                            .attr("startOffset", "50%")
                            .text(d => d3.format(".3f")(d.distance))

                    return geometry
                },
                function(update){
                    update
                        .on('mouseenter', (e,d) => showEdgeInfo('enter', e.x, e.y, d.colocsame, d.colocdiff, d.rg, d.jaccard, d.index))
                        .on('mouseleave', (e,d) => showEdgeInfo('leave', e.x, e.y, d.colocsame, d.colocdiff, d.rg, d.jaccard, d.index)); 
                    update.select('.network_jaccard_path')
                        .attr('id', (d,i) => 'network_jaccard_path' + i)
                        .attr('d', d =>  'M ' + d.source.x + ' ' + d.source.y + ' L ' + d.target.x + ' ' + d.target.y);
                    update.select('.network_jaccard_label')
                        .attr('id', (d,i) => 'network_jaccard_label' + i)
                        .attr('transform', (d,i) => getTransform(d,i))
                        .select('textPath')
                            .attr('xlink:href', (d,i) => '#network_jaccard_path' + i)
                            .text(d => d3.format(".3f")(d.distance))
      
                }
            )
        }
        var distances = []
        edges.forEach(edge => distances.push(edge.distance))
        const scaleDistance = d3.scaleLinear().domain(d3.extent(distances)).range([200, 10])
        const simulation = d3.forceSimulation(nodes)
            .force('charge', d3.forceManyBody().strength(-1500))
            .force('center', d3.forceCenter((window.innerWidth-30)*0.8/2, (contentHeight-106)/2))
            .force('link', d3.forceLink(edges)
                .id(d => d.name)
                .distance(d => scaleDistance(d.distance))
            )
            .on('tick', () => {
                updateEdges(edges);
                updateNodes(nodes);
                updateJaccards(edges);
            })
        simulation.alpha(1).restart()
        
    }

    function zoomed(e) {
        const {x,y,k} = e.transform
        d3.select("#network_graphics").attr("transform", "translate(" + x + "," + y + ")" + " scale(" + k + ")");
    }

    // var scrolled = false;
    function highlightNode (mode, code) {
        if(!document.getElementById('network_node_label_' + code)) return 
        if (mode === 'enter') {
            if (code != root && document.getElementById('n_row_' + code) != undefined) {
                if (!inView('n_row_' + code)) {
                    var y = document.getElementById('n_row_' + code).getBoundingClientRect().top + window.scrollY;
                    document.getElementById('n_inspection_content').scrollTo({top: y - 200, behavior: 'smooth'}); 
                    // scrolled = true; 
                }   
                // else {
                //     scrolled = false;
                // } 
            }
            d3.select('#n_row_' + code).select('.n_row_first').style('background-color', color.purple).selectAll('p').style('color', 'white');
            d3.select('#network_node_label_' + code).attr('fill', 'white');
            d3.select('#network_node_rect_' + code).attr('fill', color.purple).style('opacity', 1)
        } else if (mode === 'leave') {
            // if (scrolled) {
            //     document.getElementById('n_inspection_content').scrollTo({top: 0, behavior: 'smooth'});  
            //     scrolled = false;  
            // }
            d3.select('#n_row_' + code).select('.n_row_first').style('background-color', heatmap.map(el=>el.code).includes(code) ? color.lightviolet : 'white')
            d3.select('#n_row_' + code).selectAll('.n_code, .n_longname').style('color', color.purple);
            d3.select('#n_row_' + code).select('.n_status').style('color', color.pink);
            d3.select('#network_node_label_' + code).attr('fill', d => d.name === root ? 'white' : color.gray);;
            d3.select('#network_node_rect_' + code).attr('fill', d => d.name === root ? color.purple : 'white').style('opacity', 0.7)
        }
    }

    function showEdgeInfo (mode, x, y, colocsame, colocdiff, rg, jaccard, i) {
        if(!document.getElementById('network_jaccard_label' + i)) return 

        if (mode === 'enter') {
            d3.select('.edge_info_jaccard').html('Jaccard: <b>' + d3.format(".3f")(jaccard) + '</bold>');
            d3.select('.edge_info_colocsame').html('Coloc same doe: <b>' + colocsame + '</bold>');
            d3.select('.edge_info_colocdiff').html('Coloc diff. doe: <b>' + colocdiff + '</bold>');
            d3.select('.edge_info_rg').html('rg: <b>' + rg + '</bold>');
            d3.select("#tooltip")
                .style('opacity', 1)
                .style('left', x + 10 + 'px')
                .style('top', y + 10 + 'px')
            d3.select('#network_jaccard_label' + i).style('font-weight', 'bold')
            d3.select('#network_edge' + i).style('opacity', 1)
        } else if (mode === 'leave') {
            d3.select("#tooltip")
                .style('opacity', 0)   
            d3.select('#network_jaccard_label' + i).style('font-weight', 400)
            d3.select('#network_edge' + i).style('opacity', 0.35)
        }
    }

    function drawInspection (data, nodes, edges, extraNodes) {
        const nodesCodes = nodes.map(el => el.name);

        d3.select('#n_inspection_inner').selectAll('.n_row').data(data).join(
            function(enter){
                const row = enter.append('div')
                    .attr('class', 'n_row')
                    .attr('id', d => 'n_row_'+d.code)

                const first = row.append('div')
                    .attr('class', 'n_row_first n_row_inner')
                    .style('background-color', d=>heatmap.map(el=>el.code).includes(d.code) ? color.lightviolet : 'white')
                    .style('border-color', d=>color.purple )
                    .style('border-width', d=>nodesCodes.includes(d.code) ? `0.5px 0px 0.5px 0.5px` : '0px' )
                    .style('border-style', 'solid' )
                    .style('width', '60%')
                    .on('mouseenter', (e,d) => highlightNode('enter', d.code))
                    .on('mouseleave', (e,d) => highlightNode('leave', d.code));
                first.append('p').attr('class', 'n_status').html(d => format.longname(d.status));
                first.append('p').attr('class', 'n_longname').html(d => highlightNetworkQuery(format.longname(d.longname), input));
                first.append('p').attr('class', 'n_code').html(d => highlightNetworkQuery(format.name(d.code), input));

                const second = row.append('div')
                    .attr('class', 'n_row_second n_row_inner')
                    .style('width', '25%');
                second.append('p').attr('class', 'n_cases n_row_info').html(d => 'Cases: <b>' + format.count(d.cases, d.count) + '</b>');
                second.append('p').attr('class', 'n_overlap n_row_info').html(d => 'Overlap: <b>' + format.percentage(d.overlap) + '</bold>');
                second.append('p').attr('class', 'n_jaccard n_row_info').html(d => 'Proximity: <b>' + d3.format(".3f")(d.distance) + '</b>');

                const menu = row.append('div')
                    .attr('class', 'e_menu')
                    .style('width', '15%');
                menu.append('a').attr('class', 'e_row_info e_risteys').attr('target', '_blank').attr('href', d => "https://risteys.finngen.fi/endpoint/" + d.code).append('div').html('&#8594 Risteys');
                menu.append('a').attr('class', 'e_row_info e_pheweb').attr('target', '_blank').attr('href', d => "https://results.finngen.fi/pheno/" + d.code).append('div').html(d => d.core === "yes" ? '&#8594 PheWeb' : '');
                menu.append('a').attr('class', 'e_row_info e_heatmap').append('div')
                    .style('display', d => endpoint_code_cases[d.code] === undefined ? 'none' : 'block')
                    .html(d=>heatmap.map(el=>el.code).includes(d.code) ? '–\u2000 Heatmap' : '+\u2000 Heatmap')
                    .on('mouseenter', ()=>d3.select('#h_sub').style('top', '42px').style('opacity', 1))
                    .on('mouseleave', ()=>d3.select('#h_sub').style('top', '-300px').style('opacity', 0))
                    .on('click', (e,d) => {updateHeatmap(d.code, d.longname, d.cases)})
                menu.append('a').attr('class', 'e_row_info e_network').append('div')
                    .classed('e_network_active', d => nodesCodes.includes(d.code) || extraNodes.map(el => el.name).includes(d.code))
                    .html(d => nodesCodes.includes(d.code) ? '–\u2000 Network' : '+\u2000 Network')
                    .html(d => extraNodes.map(el => el.name).includes(d.code) ? '–\u2000 Network' : '+\u2000 Network')
                    .style('display', d => nodesCodes.includes(d.code) ? 'none' : 'block' )
                    .style('font-weight',800)
                    .on('click', function(e,d) {
                        const isActive = d3.select(this).classed('e_network_active')
                        d3.select(this)
                            .classed('e_network_active', !isActive)
                            .html(!isActive ? '–\u2000 Network' : '+\u2000 Network')
                        isActive ? extraNodes = extraNodes.filter(e => e.name !== d.code) : extraNodes.push({name: d.code, cases: d.cases, core: d.core});
                        setExtraNodes(extraNodes);
                        updateNetwork(edges, nodes, extraNodes);
                    })
            },
            function(update){
                update.attr('id', d => 'n_row_'+d.code);
                update.select('.n_row_first')
                    .style('background-color', d=>heatmap.map(el=>el.code).includes(d.code) ? color.lightviolet : 'white')
                    .style('border-width', d=>nodesCodes.includes(d.code) ? `0.5px 0px 0.5px 0.5px` : '0px' )
                    .style('border-color', color.purple )
                    .style('border-style', 'solid' )
                    .on('mouseenter', (e,d) => highlightNode('enter', d.code))
                    .on('mouseleave', (e,d) => highlightNode('leave', d.code));
                update.select('.n_status').html(d => format.longname(d.status));
                update.select('.n_longname').html(d => highlightNetworkQuery(format.longname(d.longname), input));
                update.select('.n_code').html(d => highlightNetworkQuery(format.name(d.code), input));
                update.select('.n_cases').html(d => 'Cases: <b>' + format.count(d.cases, d.count) + '</b>');
                update.select('.n_overlap').html(d => 'Overlap: <b>' + format.percentage(d.overlap) + '</bold>');
                update.select('.n_jaccard').html(d => 'Proximity: <b>' + d3.format(".3f")(d.distance) + '</b>');
                update.select('.e_risteys').attr('href', d => "https://risteys.finngen.fi/endpoint/" + d.code)
                update.select('.e_pheweb').attr('href', d => "https://results.finngen.fi/pheno/" + d.code)
                update.select('.e_heatmap').select('div')
                    .style('display', d => endpoint_code_cases[d.code] === undefined ? 'none' : 'block')
                    .html(d=>heatmap.map(el=>el.code).includes(d.code) ? '–\u2000 Heatmap' : '+\u2000 Heatmap')
                    .on('click', (e,d) => {updateHeatmap(d.code, d.longname, d.cases); drawInspection(data, nodes, edges, extraNodes)})
                update.select('.e_network').select('div')
                    .classed('e_network_active', d => nodesCodes.includes(d.code) || extraNodes.map(el => el.name).includes(d.code))
                    .html(d => nodesCodes.includes(d.code) ? '–\u2000 Network' : '+\u2000 Network')
                    .html(d => extraNodes.map(el => el.name).includes(d.code) ? '–\u2000 Network' : '+\u2000 Network')
                    .style('display', d => nodesCodes.includes(d.code) ? 'none' : 'block' )
                    .on('click', function(e,d) {
                        const isActive = d3.select(this).classed('e_network_active')
                        d3.select(this)
                            .classed('e_network_active', !isActive)
                            .html(!isActive ? '–\u2000 Network' : '+\u2000 Network')
                        isActive ? extraNodes = extraNodes.filter(e => e.name !== d.code) : extraNodes.push({name: d.code, cases: d.cases, core: d.core});
                        setExtraNodes(extraNodes);
                        updateNetwork(edges, nodes, extraNodes);
                    }) 
            })
    }
    function getEdges (data) {
        //console.log('getEdges', data)
        const labels = [], edges = [];

        data.forEach(edge => {
            const couple = edge.parent + '_' + edge.child,
                anticouple = edge.child + '_' + edge.parent;

            if (!labels.includes(couple) && !labels.includes(anticouple)){
                const jaccard = +edge['pheno_corr.fg-r10.jaccard_index']
                const colocs = +edge['autoreport.fg-r10.overlap_same_doe'] + +edge['autoreport.fg-r10.overlap_opposite_doe']
                const rg = +edge['ldsc_summary.fg-r10.rg']
                
                const datum = {
                    id: couple,
                    parent: edge.parent,
                    child: edge.child,
                    source: edge.source,
                    target: edge.target,
                    subsets: true,
                    jaccard: +edge['pheno_corr.fg-r10.jaccard_index'],
                    colocsame: +edge['autoreport.fg-r10.overlap_same_doe'],
                    colocdiff: +edge['autoreport.fg-r10.overlap_opposite_doe'],
                    rg: +edge['ldsc_summary.fg-r10.rg'],
                    distance: jaccard + colocs + rg,
                }
                labels.push(couple);
                edges.push(datum);  
            } else if (labels.includes(anticouple)) {
                var index = edges.map(el => el.id).indexOf(couple)
                if (index === -1) index = edges.map(el => el.id).indexOf(anticouple)
                edges[index].subsets = false
            }
        })
        return edges
        
    }

    function produceDatasets (dataset,root) {
        // console.log('1', dataset)
        // dataset = dataset.filter(e => retrieve.longname(e.child) !== undefined && retrieve.longname(e.parent) !== undefined)
        // console.log('2', dataset)
        const dataSort = dataset.sort((a,b) => d3.descending(+a['pheno_corr.fg-r10.jaccard_index'] + +a['autoreport.fg-r10.overlap_same_doe'] + +a['autoreport.fg-r10.overlap_opposite_doe'] + +a['ldsc_summary.fg-r10.rg'], +b['pheno_corr.fg-r10.jaccard_index'] + +b['autoreport.fg-r10.overlap_same_doe'] + +b['autoreport.fg-r10.overlap_opposite_doe'] + +b['ldsc_summary.fg-r10.rg']))
        const dataRelevant = dataSort.filter(e => e.parent === root || e.child === root)
        const subnetNodes = dataRelevant.map(e => [e.parent, e.child]).flat().filter((e,n,l)=>l.indexOf(e)===n).slice(0,12);
        //dataSort changed to dataRelevant
        const subnetDirty = [...dataSort.filter(e => e.parent === root || e.child === root).slice(0,12),...dataSort.filter(e => subnetNodes.includes(e.parent) || subnetNodes.includes(e.child)).slice(0,12)];
        const edgesDirty = cleanSubnet(root, subnetDirty, [], []).map(e=>{e.source = e.parent; e.target = e.child; return e})
        const nodes = edgesDirty.map(e=>[e.parent,e.child]).flat().filter((e,n,l)=>l.indexOf(e)===n).map(e=>({name: e, cases: retrieve.count(e), core: retrieve.core(e)}))
        function cleanSubnet (root, subnet, list, nodeslist) {
            const generation = subnet.filter(e=>e.parent===root||e.child===root)
            generation.forEach(e=>list.push(e))
            generation.map(e=>[e.parent,e.child]).flat().filter(e=>e!==root).forEach(e=>{
                if(!nodeslist.includes(e)){
                    nodeslist.push(e)
                    cleanSubnet( e,subnet,list,nodeslist )
                }
            })
            return list
        }

        function getInspection (data, root) {
            //console.log('getInspection', data)
            var list = []
            data.forEach(el => {
                if (retrieve.longname(el.child) !== undefined && retrieve.longname(el.parent) !== undefined) {
                    const jaccard = +el['pheno_corr.fg-r10.jaccard_index'];
                    const colocs = +el['autoreport.fg-r10.overlap_same_doe'] + +el['autoreport.fg-r10.overlap_opposite_doe'];
                    const rg = +el['ldsc_summary.fg-r10.rg'];
                    var datum;
                    if (el.parent === root) {
                            datum = {
                                overlap: el.case_overlap,
                                code: el.child,
                                longname: retrieve.longname(el.child),
                                core: retrieve.core(el.child),
                                cases: retrieve.count(el.child),
                                subsets: el.subsets,
                                status: 'Child',
                                jaccard: +el['pheno_corr.fg-r10.jaccard_index'],
                                colocsame: +el['autoreport.fg-r10.overlap_same_doe'],
                                colocdiff: +el['autoreport.fg-r10.overlap_opposite_doe'],
                                rg: +el['ldsc_summary.fg-r10.rg'],
                                distance: jaccard + colocs + rg,    
                            }
                    } else if (el.child === root) {
                            datum = {
                                overlap: +el.case_overlap,
                                code: el.parent,
                                longname: retrieve.longname(el.parent),
                                core: retrieve.core(el.child),
                                cases: retrieve.count(el.parent),
                                subsets: el.subsets,
                                status: 'Parent',
                                jaccard: +el['pheno_corr.fg-r10.jaccard_index'],
                                colocsame: +el['autoreport.fg-r10.overlap_same_doe'],
                                colocdiff: +el['autoreport.fg-r10.overlap_opposite_doe'],
                                rg: +el['ldsc_summary.fg-r10.rg'],
                                distance: jaccard + colocs + rg,
                            }    
                    }
                    list.push(datum)
                }
                
            })
            const parents = list.filter(el => el.status === 'Parent').map(el => el.code),
                children = list.filter(el => el.status === 'Child').map(el => el.code)
            //indexOf changed to lastIndexOf
            parents.forEach(parent => {
                if (children.includes(parent)) {
                    list.splice(list.map(el => el.code).lastIndexOf(parent), 1)
                    list[list.map(el => el.code).lastIndexOf(parent)].status = 'Similar' 
                }
            })
            //console.log('list3', list)
            return list
        }
        return {
            nodes: nodes,
            edges: getEdges(edgesDirty),
            inspection: getInspection(dataRelevant, root)
        }
    }

    function updateNetwork (currentEdges, currentNodes, extraNodes) {
        var finalEdges = [...currentEdges],
            finalNodes = [...currentNodes].map(node => {return {name: node.name, cases: node.cases, core: node.core}})
        
        const dataSort = props.data.sort((a,b) => d3.descending(+a['pheno_corr.fg-r10.jaccard_index'], +b['pheno_corr.fg-r10.jaccard_index']))

        extraNodes.forEach(endpoint => {

            const code = endpoint.name,
                cases = endpoint.cases,
                core = endpoint.core;
            const dataRelevant = dataSort.filter(e => e.parent === code || e.child === code)
            
            var newEdgesDirty = []
    
            const currentNodes_codes = currentNodes.map(el => el.name)
            currentNodes_codes.forEach(node => {
                dataRelevant.forEach(edge => {
                    if (edge.parent === node || edge.child === node) {
                        const newEdge = {...edge, source: edge.parent, target: edge.child}
                        newEdgesDirty.push(newEdge)}
                })
            })
    
            const newEdges = getEdges(newEdgesDirty)
            newEdges.forEach(newEdge => finalEdges.push(newEdge))
            finalNodes.push({name: code, cases: cases, core: core})
        })

        finalEdges.forEach(edge => {
            edge.source = edge.parent
            edge.target = edge.child
        })

        drawNetwork(finalEdges, finalNodes)
    }

    let datasets = produceDatasets (props.data, root)
    //let extraNodes = []
    //drawNetwork (datasets.edges, datasets.nodes);

    updateURL('network', root);
    var dep1 = JSON.stringify(datasets.inspection)
    var dep2 = JSON.stringify(datasets.nodes)
    var dep3 = JSON.stringify(datasets.edges)
    var dep4 = JSON.stringify(extraNodes)
    useEffect(()=> {
        d3.select('#network_loading').style('display', 'none');
        d3.selectAll('#network_canvas, #network_inspection').style('display', 'block');
        const svgWidth = (window.innerWidth - 30)*0.8,
            svgHeight = contentHeight - (document.getElementById('n_title').getBoundingClientRect().height || 52) -3

        d3.select('#network_svg')
            .attr('height', svgHeight)
            .attr('width', '100%')
            .attr('viewBox', `${svgWidth/4} ${svgWidth/6} ${svgWidth/2} ${svgHeight/2} `)
            .call(d3.zoom().on("zoom", zoomed))
        drawInspection (datasets.inspection, datasets.nodes, datasets.edges, extraNodes)
        drawNetwork (datasets.edges, datasets.nodes);
    }, [dep1, dep2, dep3])

    function inView(id) {
        var object = document.getElementById(id);
        var y = object.getBoundingClientRect().y
        if (y <= window.innerHeight/1.1 && y > 0) {
            return true;
        }
        else {
            return false;
        }
    }

   let input = '';

    function filterInspection(mode) {
        var startsWith = []
        var includesIt = []
        var currentData = datasets.inspection
        input = document.getElementById('network_input').value.toLowerCase();
        currentData.forEach(el => {
            if (el.code.toLowerCase().startsWith(input.replaceAll(' ', '_')) || el.longname.toLowerCase().startsWith(input)) {
                startsWith.push(el)
                currentData = currentData.filter(e => e.longname !== el.longname)
            }
        })
        currentData.forEach(el => {
            if (el.code.toLowerCase().includes(input.replaceAll(' ', '_')) || el.longname.toLowerCase().includes(input)) {
                includesIt.push(el)
            }
        })
        var filteredData = startsWith.concat(includesIt)
        if (mode == 'input') {
            if (input != '') {
                document.getElementById('network_search_cancel').style.display = 'block';
                // document.getElementById('network_block_query').innerHTML = input.toUpperCase() + ' ×';
                // document.getElementById('network_block_search').style.display = 'block';     
            }
            else {
                resetInspection();  
            }
        }
        drawInspection(filteredData, datasets.nodes, datasets.edges, extraNodes);
    }

    function resetInspection() {
        input = '';
        document.getElementById('network_input').value = '';
        document.getElementById('network_input').placeholder = 'Endpoints related to ' + format.name(root) + '...';
        // document.getElementById('network_block_search').style.display = 'none';
        document.getElementById('network_search_cancel').style.display = 'none';
        drawInspection (datasets.inspection, datasets.nodes, datasets.edges, extraNodes);
    }

    function highlightNetworkQuery(string, search) {
        if (search === undefined || search === '') return string
        else {
          const capitalized = search[0].toUpperCase() + search.slice(1).toLowerCase()
          const underscore = search.toLowerCase().replaceAll(' ', '_')
          const cases = [search.toUpperCase(), search.toLowerCase(), capitalized, underscore]
          cases.forEach(el => string = !string.includes('<span class="matchingQuery">') ? string.replace(el, '<span class="matchingQuery">' + el + '</span>') : string)
          return string
        }
    }

    return (
        <div id='network'>
            <Widget 
                trigger = {widgetState} 
                setTrigger = {setWidgetState}
                root = {widgetRoot}
                data = {widgetData}
                nodes = {datasets.nodes}
                edges = {datasets.edges}
                extraNodes = {extraNodes}
                setExtraNodes = {setExtraNodes}
                format = {format}
                retrieve = {retrieve}
                color = {color}
                updateNetwork = {updateNetwork}
                filterInspection = {filterInspection}
                resetInspection = {resetInspection}
                highlightNetworkQuery = {highlightNetworkQuery}
                produceDatasets = {produceDatasets}

            />
            <div id='network_loading'>Drawing the chart...</div>
            <div id="network_canvas" style={{display: 'none'}}>
                <div id="n_title">
                    <div className="title_inner"><h1>Overlap network</h1></div>
                    <div className="title_inner"><h2>{format.longname(undefined, root)}</h2></div>
                </div>
                <svg id="network_svg">
                    <defs>
                        <marker 
                            id="arrowhead"
                            markerWidth="6"
                            markerHeight="6"
                            refX="6"
                            refY="3"
                            orient="auto">
                                <polygon points="0 0, 6 3, 0 6" />
                        </marker>
                    </defs>
                    <g id="network_graphics">
                        <g id="network_edges" />
                        <g id="network_jaccards" />
                        <g id="network_nodes" />
                    </g>
                </svg>
                <img id="network_legend" src={legend} />
            </div>

                <div id="network_inspection">
                <div id="network_search_container" style = {{width: '98%'}}>
                    <input onKeyUp={()=>filterInspection('input')} id = "network_input" type="text" placeholder={'Endpoints related to ' + format.name(root) + '...'}></input>   
                    <button onClick={() => resetInspection()} id = "network_search_cancel">×</button>
                </div>

                {/* <div id='network_block_search'>
                    <button id='network_block_query' onClick={()=>resetInspection()}></button>
                </div> */}

                <div id="n_inspection_content" style={{height: props.contentHeight-53}}>
                    <div id="n_inspection_inner"></div>
                </div>

                </div>
        </div>
    )
}

export default Network;